import classNames from 'classnames';
import styles from './select.module.scss';

const Select = ({ className, options, selected, onChange, disabled, ariaLabel }) => (
  <div className={classNames(styles.customSelect, className, { [styles.disabled]: disabled })}>
    <select value={selected} onChange={event => onChange(event.target.value)} disabled={disabled} aria-label={ariaLabel}>
      {options.map(option => (
        <option key={option.value} value={option.value}>
          {option.text}
        </option>
      ))}
    </select>
  </div>
);

export default Select;
